import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import infoIcon from "@/assets/icons/info.svg";

const Error = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        color: muiTheme.colorSchemes.light.palette.neutral[700],
      }}
    >
      <Box
        sx={{
          width: "70px",
          height: "70px",
          padding: "14px",
          backgroundColor: "#FDDDB3",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          marginBottom: 1,
        }}
      >
        <img src={infoIcon} width={60} height={60} alt="Not Found" />
      </Box>
      <Typography
        variant="h3_reg"
        sx={{
          textAlign: "center",
          ...muiTheme.typography.h3_reg,
        }}
      >
        Something Went Wrong
      </Typography>
    </Box>
  );
};

export default Error;
